/**
 * Initializes Swiper for complementary products only when slides exist
 * (including after async recommendations inject HTML into [data-complementary-products]).
 *
 * Visible count at large breakpoints comes from the Complementary products block setting
 * "Number of products per page" (block.settings.products_per_slide), exposed as
 * data-products-per-slide on [data-complementary-products] and [data-complementary-carousel].
 */
(function () {
  if (typeof Swiper === 'undefined') return;

  function getCardWidthPx(rootEl, carousel) {
    // Priority:
    // 1) data-complementary-card-width on carousel/root
    // 2) CSS variable --complementary-card-width on root
    // 3) fallback 92
    var rawAttr =
      (carousel && carousel.getAttribute('data-complementary-card-width')) ||
      (rootEl && rootEl.getAttribute('data-complementary-card-width'));
    var attr = rawAttr ? parseFloat(rawAttr) : NaN;
    if (Number.isFinite(attr) && attr > 0) return attr;

    if (rootEl && window.getComputedStyle) {
      var cssVar = getComputedStyle(rootEl).getPropertyValue('--complementary-card-width');
      var css = cssVar ? parseFloat(cssVar) : NaN;
      if (Number.isFinite(css) && css > 0) return css;
    }

    return 92;
  }

  function applySlideWidths(swiperEl, widthPx) {
    if (!swiperEl) return;
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    slides.forEach(function (slide) {
      slide.style.width = widthPx + 'px';
    });
  }

  function setNavVisibility(swiper, prev, next) {
    if (!prev || !next) return;
    // When Swiper doesn't overflow, it "locks" and there is nothing to navigate.
    // Hide arrows in that case; show them only when there are more items than visible width.
    var shouldShow = !!(swiper && swiper.enabled && !swiper.isLocked);
    prev.style.display = shouldShow ? '' : 'none';
    next.style.display = shouldShow ? '' : 'none';
  }

  function initOne(rootEl) {
    var swiperEl = rootEl.querySelector('[data-complementary-swiper]:not([data-complementary-swiper-ready])');
    if (!swiperEl) return;
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    var carousel = rootEl.querySelector('[data-complementary-carousel]');
    var prev = carousel ? carousel.querySelector('[data-complementary-prev]') : null;
    var next = carousel ? carousel.querySelector('[data-complementary-next]') : null;
    var cardWidthPx = getCardWidthPx(rootEl, carousel);

    // With slidesPerView:'auto', Swiper uses each slide's CSS width.
    // Setting fixed px width enables the "partial last card" look when remaining space < card width.
    applySlideWidths(swiperEl, cardWidthPx);

    swiperEl.setAttribute('data-complementary-swiper-ready', '');

    var nav =
      prev && next
        ? {
            prevEl: prev,
            nextEl: next,
          }
        : undefined;

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 4,
      loop: false,
      speed: 400,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      roundLengths: true,
      navigation: nav,
      on: {
        init: function () {
          setNavVisibility(this, prev, next);
        },
        observerUpdate: function () {
          setNavVisibility(this, prev, next);
        },
        update: function () {
          setNavVisibility(this, prev, next);
        },
        resize: function () {
          // Re-apply in case theme code re-renders slides or widths get reset.
          applySlideWidths(swiperEl, getCardWidthPx(rootEl, carousel));
          setNavVisibility(this, prev, next);
        },
        slideChange: function () {
          setNavVisibility(this, prev, next);
        },
      },
    });

    // Some themes/content injections can override slide styles after init.
    // Re-apply once after initialization to keep widths consistent.
    try {
      applySlideWidths(swiperEl, cardWidthPx);
      swiper.update();
      setNavVisibility(swiper, prev, next);
    } catch (e) {}
  }

  function watchRoot(rootEl) {
    if (!rootEl || rootEl.__complementarySliderObserved) return;
    rootEl.__complementarySliderObserved = true;

    var mo = new MutationObserver(function () {
      initOne(rootEl);
    });
    mo.observe(rootEl, { childList: true, subtree: true });
    initOne(rootEl);
  }

  function scanDocument() {
    document.querySelectorAll('[data-complementary-products]').forEach(watchRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanDocument);
  } else {
    scanDocument();
  }
})();